interface IBasketWithItemsProps {
  color: 'white' | 'blue' | 'black';
  quantity?: number;
  style: {};
}

import * as S from './styles';

export function BasketWithItems({
  color,
  quantity = 0,
  style,
}: IBasketWithItemsProps) {
  return (
    <S.Container className="basket-with-items" style={style}>
      <div>
        {color === 'black' ? (
          <img
            src="/images/icons/basket-black.svg"
            alt="Cesta"
            className="icon shopping-icon"
          />
        ) : (
          <img
            src="/images/icons/basket.svg"
            alt="Cesta"
            className="icon shopping-icon"
          />
        )}

        <span className="quantity-itens-in-cart">{quantity}</span>
      </div>
    </S.Container>
  );
}
